import { ref, computed, onBeforeMount } from "vue";
import { useRoute, useRouter } from "vue-router";

export function useFilter(filterKeys) {
  const filters = ref({});

  const { replace } = useRouter();
  const route = computed(() => useRoute());

  const fillFilters = () => {
    const query = route.value.query;

    if (query && Object.keys(query).length) {
      for (const filterKey of filterKeys) {
        if (query[filterKey]) {
          filters.value = { ...filters.value, [filterKey]: query[filterKey] };
        }
      }
    }
  };

  onBeforeMount(() => {
    fillFilters();
  });

  const getPaginationFromUrl = () => {
    const query = { ...route.value.query };

    let newQuery = {};
    const paginationItems = ["page", "itemPerPage"];

    for (const paginationItem of paginationItems) {
      if (query[paginationItem]) {
        newQuery = { ...newQuery, [paginationItem]: query[paginationItem] };
      }
    }
    return newQuery;
  };

  const clearFilter = () => {
    const newQuery = getPaginationFromUrl();

    filters.value = {};

    replace({ query: newQuery });
    return true;
  };

  const addFilterToUrl = () => {
    const newQuery = getPaginationFromUrl();
    const copyFilters = { ...filters.value };

    for (const key in copyFilters) {
      if (Object.hasOwnProperty.call(copyFilters, key)) {
        if (
          copyFilters[key] === "" ||
          copyFilters[key] === undefined ||
          copyFilters[key] === null
        ) {
          delete copyFilters[key];
        }
      }
    }

    filters.value = { ...copyFilters };

    replace({ query: { ...copyFilters, ...newQuery, page: 1, itemPerPage: 10 } });
  };

  return {
    filters,
    clearFilter,
    fillFilters,
    addFilterToUrl,
  };
}
